// Mapping of Order Status codes to French labels (for frontend use)
export const ORDER_STATUS_LABELS = {
  0: 'En Attente',
  1: 'En Pickup',
  2: 'Colis au dépôt',
  3: 'En cours',
  4: 'Livré',
  5: 'Retour au dépôt',
  6: 'Livré payé',
  7: 'Retour au fournisseur',
  8: 'En Transfert',
  9: 'Retour payé',
  10: 'return inter agency',
  11: 'return inter agency received',
  12: 'Colis annulé par admin',
  13: 'Colis perdu',
  14: 'À vérifier',
  15: 'En attente de collecte',
  16: 'A rembourser',
  17: 'Remboursé',
  18: 'Planification',
}

export function getOrderStatusLabel(status) {
  if (status == null || status === undefined) return '-'
  return ORDER_STATUS_LABELS[status] || status
}
